export default "__VITE_ASSET__6edabff8__"